import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Login from './Components/Login';
import Register from './Components/Register';
import Redirect from './Components/Redirect';
import { ResetPassword } from './Components/ResetPassword';
import Users from './Components/Users';
import Landing from './pages/Landing';
import ResetPasswordPopup from './Components/ResetPasswordPopup';
import ForgotPassword from './Components/ForgotPassword';
import Layout from './Layout/Layout';
import NewReset from './Components/NewReset';
import { ToastContainer } from "react-toastify";

const App = () => {

  //const BASEURL = 'https://koelsmartenergy.com/cred';
  const BASEURL = window.location.origin.includes("www.koelsmartenergy.com")
    ? "https://www.koelsmartenergy.com/cred"
    : "https://koelsmartenergy.com/cred";
  //const BASEURL = 'http://13.126.205.156:5002/cred';

  return (
    <div className="overflow-hidden">
      <Router>
        <Routes>
          <Route path="/register" element={<Register BASEURL={BASEURL} />} />
          <Route path="/" element={<Login BASEURL={BASEURL} />} />
          <Route path="/redirect" element={<Redirect BASEURL={BASEURL} />} />
          <Route path="/reset-password/:token" element={<NewReset />} />

          <Route element={<Layout />}>
            <Route path='/dashboard' element={<Landing />} />
            <Route path='/users' element={<Users />} />
          </Route>
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/reset-password' element={<NewReset />} />



        </Routes>
      </Router>
      <ToastContainer position="top-center" autoClose={3000} />
    </div>
  );
};

export default App;
